import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getFuelStationRawEvents(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_RAW_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENTS,
    options
  )
}

function _getFuelStationRawEvent(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_RAW_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT,
    options
  )
}

function _getFuelStationRawEventPreview(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATION_RAW_EVENTS,
    ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT_PREVIEW,
    options
  )
}


export default {
  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENTS]: _getFuelStationRawEvents,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT]: _getFuelStationRawEvent,
  [ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT_PREVIEW]: _getFuelStationRawEventPreview,
}
